import React from "react";
import CommunityViewPage from "../community/components/CommunityViewPage";
import { ASK_FOR_HELP } from "../community/constants";

export default function ViewAskForHelpPage() {
  return <CommunityViewPage section={ASK_FOR_HELP} />;
}
